import { del, get, post, put } from "helpers/api_helper"

const PRODUCTS_REVIEWS_BASE_URL = "/product-reviews"
const PRODUCTS_SPECIFICATIONS_BASE_URL = "/product-specifications"
const PRODUCTS_BASE_URL = "/products"

export const createProductReviewService = (payload, rejectWithValue) => post(PRODUCTS_REVIEWS_BASE_URL, payload, {}, rejectWithValue)
export const showProductReviewService = (params, rejectWithValue) => get(`${PRODUCTS_BASE_URL}/${params}`, {}, rejectWithValue)
export const getProductSpecificationsService = (params, rejectWithValue) => get(`${PRODUCTS_SPECIFICATIONS_BASE_URL}/${params}`, {}, rejectWithValue)